import {createContext, useContext} from 'react'
import {triggerReloadInterface} from '../global'

interface SAVContextInterface extends triggerReloadInterface {
  status: SAVTicketStatus[];
  urgency: SAVTicketStatus[];
}

export const SAVContext = createContext<SAVContextInterface | undefined>(undefined)

export interface SAVApiStatusResponse {
  status: SAVTicketStatus[];
  message_code: string;
  urgency: SAVTicketStatus[];
}

export interface SAVTicketStatus {
  id: number;
  name: string;
  color: string;
}

export interface SAVProductAssignResponse {
  status: number
  message_code: string
  products: SAVProduct[]
  assigns: SAVAssign[]
}

export interface SAVProduct {
  id: number
  name: string
}

export interface SAVAssign {
  id: number
  name: string
  product_id: number
}

export interface SAVAttachment {
  src: string;
  type: string;
  size: string;
  name: string;
}

export interface SAVSatisfaction {
  id: number;
  client_id: number;
  comments: string;
  rating: number
}

export interface SAVTicketType {
  id: number;
  created_at: string;
  description: string;
  product: string;
  count_message: number;
  status: string;
  subject: string;
  assign: string;
  attachment: SAVAttachment[];
  satisfaction: SAVSatisfaction | null
}

export interface SAVTickets {
  tickets: SAVTicketType[] | null
}

export interface SAVTransformedTicket extends Omit<SAVTicketType, 'status'> {
  status: SAVTicketStatus
}

export interface SAVResponsesTicket extends SAVTicketType {
  id: number
  client_id: number
  user_id: number
  created_at: string
  message: "message" | "response" | string
  sav_ticket_id: number
  type: string
  attachments: SAVAttachment[];
}

export const useSAV = () => {
  const context = useContext(SAVContext)
  if (!context) throw new Error("useSAV must be used within SAVProvider")
  return context
}